import { SearchHistory } from './components/SearchHistory'
import { SearchFilters } from './components/SearchFilters'
import { Spinner } from '@/view/components/ui/spinner'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/view/components/ui/sheet'
import TransactionDetails from '../Dashboard/components/TransactionTable/components/TransactionDetails'
import { useSupportController } from './useSupportController'
import { TableSupport } from './components/TableSupport'

export const Support = () => {
  const {
    data,
    handleMakeFetchAgain,
    handleRowClick,
    handleSearch,
    handleSheetState,
    isFetching,
    isLoading,
    selectedId,
    preparedData,
    searchQuery,
    selectedFilters,
    setSelectedFilters,
    setSheetOpen,
    sheetOpen,
  } = useSupportController()

  return (
    <div>
      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetContent className="w-[340px] overflow-y-auto rounded-2xl bg-[#F4F5F7] p-2 xs:mr-5 xs:mt-5 xs:h-[95%] xs:w-96 xs:p-5">
          <div className="min-h-[800px]">
            <SheetHeader>
              <SheetTitle className="text-xl font-semibold">
                <div className="flex items-center justify-between">
                  <h2>Detalhes da transação</h2>
                </div>
                <div className="my-5 w-full border-b-[1px] border-gray01" />
              </SheetTitle>
            </SheetHeader>
            {selectedId && <TransactionDetails />}
          </div>
        </SheetContent>
      </Sheet>
      <div className="space-y-8 pb-10">
        <SearchFilters
          selectedFilters={selectedFilters}
          onFilterChange={setSelectedFilters}
          searchValue={searchQuery}
          onSearchChange={handleSearch}
        />
        {isFetching || isLoading ? (
          <div className="flex h-screen items-center justify-center">
            <Spinner />
          </div>
        ) : searchQuery === '' && data ? (
          <SearchHistory
            handleMakeFetchAgain={handleMakeFetchAgain}
            supports={data.supports}
          />
        ) : (
          preparedData && (
            <TableSupport
              data={preparedData}
              handleRowClick={handleRowClick}
              handleSheetState={handleSheetState}
            />
          )
        )}
      </div>
    </div>
  )
}
